import React from 'react';

import BankingCard, { Last4Digits } from '@apigrowfinance/pbolt-banking-card';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { useIntl } from 'react-intl';

import pismo from '@assets/img/pismo.png';
import { CustomerCard } from '@clients/customersClient';
import cardAltText from '@messages/cardAltText';
import getEnumTranslation from '@utils/getEnumTranslation';

export interface BankingCardDecorator {
    card: CustomerCard;
    isLoading: boolean;
}

const BankingCardDecorator = ({
    card,
    isLoading = false,
}: BankingCardDecorator) => {
    const { theme } = useTheme();
    const { formatMessage } = useIntl();

    return (
        <BankingCard
            last4Digits={card?.last_4_digits as Last4Digits}
            expiryDate={card?.expiration_date}
            fontScale={0.75}
            printedName={card?.printed_name}
            foregroundLogo={{
                image: theme?.custom?.brand?.brandImage || pismo,
                altText:
                    theme?.custom?.brand?.brandName ||
                    getEnumTranslation('cardForegroundAltText', {
                        messages: cardAltText,
                        formatMessage,
                    }),
            }}
            backgroundLogo={{
                image: theme?.custom?.brand?.brandImageSmall,
                altText:
                    theme?.custom?.brand?.brandName ||
                    getEnumTranslation('cardBackgroundAltText', {
                        messages: cardAltText,
                        formatMessage,
                    }),
            }}
            isLoading={isLoading}
        />
    );
};

export default BankingCardDecorator;
